import React, { useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { GridItem, MasonryGrid, useTheme } from "datastory-shared/ui"
import { useIsomorphicLayoutEffect } from "datastory-shared/utils/hooks"
import { isBrowser } from "datastory-shared/utils/browser"

import { Item } from "./Item"

export const Listing = ({
  glossaryItems,
  selectedCategory,
  sortBy,
  viewType,
}) => {
  const { breakpoints, customComponents } = useTheme()
  const [isDesktop, setIsDesktop] = useState(true)

  const {
    image: { baseUrl },
  } = customComponents

  const checkIsDesktop = useCallback(
    width =>
      width >
      parseFloat(breakpoints.md.slice(0, breakpoints.md.length - 3)) * 16,
    [breakpoints]
  )

  useIsomorphicLayoutEffect(() => {
    if (isBrowser) setIsDesktop(checkIsDesktop(window.screen.width))
  }, [checkIsDesktop])

  const preparedGlossaryItems = useMemo(
    () =>
      glossaryItems
        .filter(i =>
          selectedCategory === "all"
            ? true
            : i.og_datastoryGlossaryCategory
                .map(i => i.entity_meta.local_id)
                .includes(selectedCategory)
        )
        .sort((a, b) => {
          if (sortBy === "desc")
            return a.og_name[0]?.i18n.localeCompare(b.og_name[0]?.i18n)
          else if (sortBy === "asc")
            return b.og_name[0]?.i18n.localeCompare(a.og_name[0]?.i18n)
          else if (sortBy === "date-desc")
            return (
              new Date(b.og_publishedAt[0]?.postgres_timestamptz) -
              new Date(a.og_publishedAt[0]?.postgres_timestamptz)
            )
          else if (sortBy === "date-asc")
            return (
              new Date(a.og_publishedAt[0]?.postgres_timestamptz) -
              new Date(b.og_publishedAt[0]?.postgres_timestamptz)
            )
        }),
    [glossaryItems, selectedCategory, sortBy]
  )

  return (
    <MasonryGrid
      gridAutoRows={"auto"}
      gridRowGap={["md", "md", "sm"]}
      disableMasonry={!isDesktop || viewType === "listing"}
      data-cy="listing"
    >
      {preparedGlossaryItems.map(i => (
        <GridItem
          key={i.id}
          className="item"
          gridAutoRows="auto"
          colSpan={viewType === "grid" ? [4, 6, 3, 4, 4] : [4, 6, 6, 12, 12]}
        >
          <Item
            {...i}
            viewType={isDesktop ? viewType : "grid"}
            baseUrl={baseUrl}
          />
        </GridItem>
      ))}
    </MasonryGrid>
  )
}

Listing.propTypes = {
  glossaryItems: PropTypes.array,
  selectedCategory: PropTypes.string,
  sortBy: PropTypes.string,
  viewType: PropTypes.oneOf(["listing", "grid"]),
}
